import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

export default function Adminhomemenu(props) {
  const navigate = useNavigate();

  const langMap = {
    1: "EN",
    2: "GU",
    3: "HI",
  };

  const reverseLangMap = {
    EN: "1",
    GU: "2",
    HI: "3",
  };

  const [language, setLanguage] = useState("EN");
  const [itiName, setItiName] = useState("");
  const [showITIInput, setShowITIInput] = useState(false);

  // 🔥 Load language + ITI name
  useEffect(() => {
    const storedLang = localStorage.getItem("language");
    if (storedLang && langMap[storedLang]) {
      setLanguage(langMap[storedLang]);
    }

    const user = JSON.parse(localStorage.getItem("user"));
    const name = user?.ITI_NAME;

    if (name && name.trim() !== "") {
      setItiName(name);
      setShowITIInput(false);
    } else {
      setShowITIInput(true);
    }
  }, []);

  const logout = () => {
    localStorage.clear();
    navigate("/");
  };

  // 🌐 Language Change
  const changeLanguage = async (e) => {
    const selectedLang = e.target.value;
    const LANGUAGE_ID = reverseLangMap[selectedLang];
    const user = JSON.parse(localStorage.getItem("user"));
    const UID = user?.UID;

    try {
      const path = `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_UPDATE_LANGUAGE}`;

      const response = await fetch(path, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          LANGUAGE_ID,
          UID,
        }),
      });

      const data = await response.json();

      if (data.res === "success") {
        setLanguage(selectedLang);
        localStorage.setItem("language", LANGUAGE_ID);
      } else {
        alert("Language update failed");
      }
    } catch (error) {
      console.error("API error:", error);
    }
  };

  // ✅ Save ITI Name
  const saveITIName = async () => {
    if (!itiName.trim()) {
      alert("Enter ITI Name");
      return;
    }

    const user = JSON.parse(localStorage.getItem("user"));
    const UID = user?.UID;

    try {
      const path = `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_UPDATE_ITI_NAME}`;

      const response = await fetch(path, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          UID,
          ITI_NAME: itiName,
        }),
      });

      const data = await response.json();

      if (data.res === "success") {
        // ✅ localStorage update
        const updatedUser = {
          ...user,
          ITI_NAME: itiName,
        };

        localStorage.setItem("user", JSON.stringify(updatedUser));
        //const ITI_NAME =(user?.ITI_NAME || "").toUpperCase();
        setShowITIInput(false);

        console.log("✅ ITI Name Updated");
      } else {
        alert("ITI Name update failed");
      }
    } catch (error) {
      console.error("❌ API Error:", error);
      alert("Server error");
    }
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-dark fixed-top">
      <div className="container-fluid">
        <Link className="navbar-brand fw-bold" to="/adminhome">
          {props.title}
        </Link>

        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#adminNavbar"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="adminNavbar">
          <ul className="navbar-nav me-auto">
            <li className="nav-item">
              <Link className="nav-link" to="/readquestion">
                Read Question
              </Link>
            </li>

            <li className="nav-item">
              <Link className="nav-link" to="/createtest">
                Create Test
              </Link>
            </li>

            <li className="nav-item">
              <Link className="nav-link" to="/createrendomtest">
                Create Random Test
              </Link>
            </li>

            <li className="nav-item">
              <Link className="nav-link" to="/testhistory">
                Test History
              </Link>
            </li>

            <li className="nav-item">
              <Link className="nav-link" to="/createquestionpaper">
                Create Question Paper
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/aboutEasyiti">
                About Us
              </Link>
            </li>

            <li className="nav-item">
              <Link className="nav-link" to="/privacy-policy-admin">
                Privacy Policy
              </Link>
            </li>
            {/* 🌐 LANGUAGE */}
            <li className="nav-item d-flex align-items-center ms-lg-3">
              <select
                className="form-select form-select-sm bg-dark text-white border-secondary"
                value={language}
                onChange={changeLanguage}
              >
                <option value="EN">English</option>
                <option value="GU">Gujarati</option>
                <option value="HI">Hindi</option>
              </select>
            </li>

            {/* 🏫 ITI NAME */}
            {/* 🏫 ITI NAME */}
            <li className="nav-item d-flex align-items-center ms-lg-3 text-white">
              {showITIInput ? (
                <>
                  <input
                    type="text"
                    className="form-control form-control-sm me-2"
                    placeholder="Enter ITI Name"
                    value={itiName}
                    onChange={(e) => setItiName(e.target.value)}
                  />
                  <button
                    className="btn btn-success btn-sm me-2"
                    onClick={saveITIName}
                  >
                    Save
                  </button>

                  <button
                    className="btn btn-secondary btn-sm"
                    onClick={() => setShowITIInput(false)}
                  >
                    Cancel
                  </button>
                </>
              ) : (
                <>
                  <span className="fw-bold me-2">{itiName}</span>

                  <button
                    className="btn btn-outline-light btn-sm"
                    onClick={() => setShowITIInput(true)}
                  >
                    ✏️
                  </button>
                </>
              )}
            </li>
          </ul>

          <button onClick={logout} className="btn btn-outline-light btn-sm">
            Log out
          </button>
        </div>
      </div>
    </nav>
  );
}
